import { deepcopy, getComplementaryColor, search_asp, trimFieldString } from "../util";

export function translateLeaveMinMax(tech, args, line, parsed, source, mapping, processed, config) {
  // do(leave_min_max_on,RC,I,for_tiny)
  let rules = [];
  let rci = mapping[args[1]]["layout." + args[0]]
  let rc = source?.layout?.[args[0]]?.[rci];
  if (rc) {
    let field = rc.field;
    let data = {};
    let min = source?.datatype?.[field]?.min,
      max = source?.datatype?.[field]?.max;
    data[field] = {
      xrange: [min, max]
    };
    if (min !== undefined && max !== undefined) {
      let rule = {
        category: "recommender",
        description: `Remove a data subset`,
        specifier: {
          role: "data",
          data
        },
        action: "remove"
      };
      rules.push(rule);
      if (source.layer) {
        source.layer.forEach((layer, li) => {
          layer.text?.forEach((text) => {
            if (text.field === field && text.type === "on-axis") {
              let rule_text = {
                category: "recommender",
                description: "Modify axis values",
                specifier: {
                  role: "axis.label",
                  field,
                },
                action: "modify",
                option: {
                  values: [min, max]
                }
              };
              if (layer.name) rule_text.layer = { id: layer.name };
              else rule_text.layer = { index: li };
              rules.push(rule_text);
            }
          });
        })
      }
    }
    let agg = search_asp(parsed, "do(aggregate_with_leave_min_max_on,", "startsWith")[0];
    if (agg) {
      // do(aggregate_with_leave_min_max_on,RC,R,M,for_tiny)
      let rci_agg = mapping[agg.args[2]]["layout." + agg.args[1]];
      let rc_agg = source?.layout?.[agg.args[1]]?.[rci_agg];
      let agg_method = agg.args[3];
      if (rc_agg) {
        let rule = {
          category: "recommender",
          description: `Aggregate (${agg_method}) for ${rc_agg.field}`,
          specifier: {
            role: agg.args[1],
            field: rc_agg.field
          },
          action: "modify",
          option: {
            aggregate: agg_method
          }
        };
        rules.push(rule);
      }
    }
  }
  return rules;
}

export function translateLeaveHighlightOnly(tech, args, line, parsed, source, mapping, processed, config) {
  // do(leave_highlights_only,F,by_mark_label,T,for_tiny)
  let rules = [];
  let field = trimFieldString(args[0]);
  if (args[1] === "by_mark_label") {
    let layer = source.layer[mapping[args[2]].layer];
    let text = layer?.text[mapping[args[2]].text];
    if (layer && text) {
      let expression = getArrayFilterExpr(field, text.values)
      let rule = {
        category: "recommender",
        description: `Add a data filter`,
        specifier: {
          role: "transform"
        },
        action: "add",
        option: {
          operation: "filter",
          expression
        }
      };
      rules.push(rule);
    }
  }
  return rules;
}

function getArrayFilterExpr(field, v) {
  return "(" + v.map((d) => 'datum.' + field + " == " + (d.constructor.name === "Number" ? d.toString() : `"${d}"`)).join(" || ") + ")"
}

export function translateAggregateMultiples(tech, args, line, parsed, source, mapping, processed, config) {
  // aggregate_multiples
  let rules = [];
  let split_field = source.layout?.split?.field;
  // let has_opacity_enc = source.layer?.[0]?.mark?.opacity?.field || source.layer?.[0]?.mark?.opacity?.aggregate;
  // layout conversion
  rules.push({
    category: "recommender",
    description: `Change layout composition to single`,
    specifier: { role: "view" },
    action: "modify",
    option: {
      composition: "single",
      split: null,
      nColumns: null
    }
  });
  // add aggregate
  if (split_field) {
    rules.push({
      category: "recommender",
      description: `Aggregate y axis`,
      specifier: { role: "row", index: 0 },
      action: "modify",
      option: {
        aggregate: "sum"
      }
    });
  }
  // opacity adjustment
  // if (!has_opacity_enc) {
  //   rules.push({
  //     category: "recommender",
  //     description: `Change the opacity`,
  //     specifier: { role: "mark" },
  //     action: "modify",
  //     option: {
  //       opacity: {
  //         value: 0.7
  //       }
  //     }
  //   });
  // }
  return rules;
}

export function translateLineMultiplesToOveralys(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let split_field = source.layout?.split?.field;
  let has_opacity_enc = source.layer?.[0]?.mark?.opacity?.field || source.layer?.[0]?.mark?.opacity?.aggregate;
  // layout conversion
  rules.push({
    category: "recommender",
    description: `Change layout composition to single`,
    specifier: { role: "view" },
    action: "modify",
    option: {
      composition: "single",
      split: null,
      nColumns: null
    }
  });
  // add detail encoding
  if (split_field) {
    rules.push({
      category: "recommender",
      description: `Add line grouping`,
      specifier: { role: "mark" },
      action: "modify",
      option: {
        detail: {
          field: split_field
        }
      }
    });
  }
  // opacity adjustment
  if (!has_opacity_enc) {
    rules.push({
      category: "recommender",
      description: `Change the opacity`,
      specifier: { role: "mark" },
      action: "modify",
      option: {
        opacity: {
          value: 0.7
        }
      }
    });
  }
  return rules;
}

export function translateAddMarkHighlights(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(add_mark_highlights,by_data_annotation,A,L,stroke,for_tiny)
  if (args[0] === "by_data_annotation") {
    let anno = source.annotation?.items?.[mapping[args[1]].annotation];
    let layer = source.layer?.[mapping[args[2]].layer];
    let hl_type = args[3];
    let rule = {
      category: "recommender",
      description: `Highlight the mark indicated by the ${anno.name || ""}`,
      specifier: {
        role: "mark",
      },
      action: "modify",
      option: {
      }
    };
    rule.specifier.data = deepcopy(anno.anchor?.dataItem?.datum)
    if (hl_type == "fill") {
      rule.option.fill = { value: (layer.mark.fill?.value ? getComplementaryColor(layer.mark.fill?.value, "rgba") : "rgba(255,0,0,1)") };
      rule.option.stroke = { value: "rgba(0,0,0,1)" };
      rule.option.strokeWidth = { value: 1 };
    } else if (hl_type == "stroke") {
      rule.option.stroke = { value: (layer.mark.fill?.value ? getComplementaryColor(layer.mark.fill?.value, "rgba") : "rgba(0,0,0,1)") };
      rule.option.strokeWidth = { value: 2 };
      rule.option.strokeOpacity = { value: 1 };
    } else if (hl_type == "strokeWidth") {
      rule.option.strokeWidth = { value: 2 };
      rule.option.strokeOpacity = { value: 1 };
    }
    if (layer.name) rule.specifier.id = layer.name;
    else rule.specifier.index = parseInt(mapping[args[2]].layer);
    if (Object.keys(rule.option).length > 0 && Object.keys(rule.specifier.data).length > 0) {
      rules.push(rule);
    }
  }
  return rules;
}